import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Service } from '../types';

interface ServiceCardProps {
  service: Service;
  index: number;
}

const getServiceUrl = (title: string): string => {
  const urlMap: { [key: string]: string } = {
    'Cognitive Reach': '/services/cognitive-reach',
    'Cognitive Build': '/services/cognitive-build',
    'Cognitive Intelligence': '/services/cognitive-intelligence',
    'Cognitive Cloud': '/services/cognitive-cloud',
    'Cognitive IoT': '/services/cognitive-iot',
    'Cognitive Secure': '/services/cognitive-secure',
    'Cognitive Agents': '/services/cognitive-agents',
    'Cognitive Generate': '/services/cognitive-generate',
    'Cognitive Vision': '/services/cognitive-vision',
    'Cognitive Voice': '/services/cognitive-voice',
    'Cognitive Predict': '/services/cognitive-predict',
    'Cognitive Compliance': '/services/cognitive-compliance',
    'Cognitive Train': '/services/cognitive-train',
    'Cognitive Ledger': '/services/cognitive-ledger'
  };
  return urlMap[title] || '/services';
};

export const ServiceCard: React.FC<ServiceCardProps> = ({
  service,
  index,
}) => (
  <Link 
    to={getServiceUrl(service.title)}
    className="group relative block p-8 bg-white/80 dark:bg-white/5 backdrop-blur-sm rounded-2xl border border-gray-200 dark:border-white/10 hover:bg-gray-50 dark:hover:bg-white/10 hover:border-blue-600 dark:hover:border-blue-400 transition-all duration-500 hover:scale-105 hover:shadow-xl hover:shadow-blue-600/30"
  >
    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-blue-700/5 dark:from-blue-400/10 dark:to-blue-400/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    

    <div className="relative">
      <div className="text-blue-600 dark:text-blue-400 mb-4 group-hover:scale-110 group-hover:text-blue-700 dark:group-hover:text-blue-400 transition-all duration-300">
        {service.icon}
      </div>

      <h3 className="text-xl font-bold mb-2 text-gray-900 dark:text-white group-hover:text-blue-700 dark:group-hover:text-blue-400 transition-all duration-300">
        {service.title}
      </h3>

      <p className="text-blue-600 dark:text-blue-400 text-sm mb-4 font-medium group-hover:text-blue-700 dark:group-hover:text-blue-300 transition-colors duration-300">
        {service.subtitle}
      </p>

      <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6 group-hover:text-gray-900 dark:group-hover:text-white transition-colors duration-300">{service.description}</p>

      <div className="flex items-center text-blue-600 dark:text-blue-400 group-hover:text-blue-700 dark:group-hover:text-blue-300 transition-colors duration-300">
        <span className="text-sm font-semibold">Explore Service</span>
        <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-2 transition-transform duration-300" />
      </div>
    </div>
  </Link>
);